import { collection, addDoc, getDocs } from "firebase/firestore";
import { db } from "../config/firestore";
import Swal from "sweetalert2";
import ReactGA from "react-ga";

// Helper function to show SweetAlert errors
const showError = (title, text) => {
  Swal.fire({
    icon: "error",
    title,
    text,
    showConfirmButton: true,
    customClass: { confirmButton: "confirm-button-class" },
    iconColor: "red",
  });
};

const validateInput = (searchQuery, crn) => {
  if (searchQuery === "") {
    showError("No input", "Please enter an input");
    return false;
  }
  return true;
};

const checkAvailability = async (crn) => {
  const response = await fetch(
    "https://www.hokiehelper.com/api/check_if_open",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ crn: parseInt(crn) }),
    }
  );
  return response.json();
};

const checkForDuplicates = async (collectionName, field, value, crn) => {
  const snapshot = await getDocs(collection(db, collectionName));
  snapshot.forEach((doc) => {
    if (doc.get(field) === value && doc.get("crn") === crn) {
      showError(
        "Repeat!",
        `This crn and ${field} combination is active already.`
      );
      throw new Error();
    }
  });
};

const addDocToFirestore = async (collectionName, payload) => {
  await addDoc(collection(db, collectionName), payload);

  Swal.fire({
    icon: "success",
    title: "Confirmed!",
    text: `As soon as a spot opens in course ${payload.crn} we will contact you.`,
    showConfirmButton: true,
    customClass: { confirmButton: "confirm-button-class" },
    iconColor: "green",
  });
};

export const handleAddLogic = async (commMethod, searchQuery, crn) => {
  if (!validateInput(searchQuery, crn)) return;

  try {
    const data = await checkAvailability(crn);

    if (data.result === "Empty") {
      showError("Open spots!", "This class has space available.");
      throw new Error();
    }

    if (data.result === "Not Found") {
      showError("Invalid CRN!", "This is not a valid course number.");
      throw new Error();
    }

    if (commMethod === "email") {
      await checkForDuplicates("email", "email", searchQuery, crn);
      await addDocToFirestore("email", { email: searchQuery, crn });
      ReactGA.event({ 
        category: 'User Actions',
        action: 'Add email',
        label: 'Email Added',
        nonInteraction: true,
        value: 1,
        trackerNames: ['tracker1'],
      });
    } else if (commMethod === "text") {
      await checkForDuplicates("text", "number", searchQuery, crn);
      await addDocToFirestore("text", { number: searchQuery, crn });
      ReactGA.event({ 
        category: 'User Actions',
        action: 'Add text',
        label: 'text Added',
        nonInteraction: true,
        value: 1,
        trackerNames: ['tracker1'],
      });
    } else {
      showError("Method not picked", "We couldn't read what method you used");
    }
  } catch (e) {
    console.log("Error! ", e);
  }
};
